module.exports = __webpack_public_path__ + "static/dignitas-bold-11526431dfa94b0860b8f7674b35b0e1.woff";